import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import AdminView from '@admin/App';
import AdminProvider from '@admin/contexts/AdminContext';
import NavigationBlockerProvider from '@contexts/NavigationBlocker';

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <AdminProvider>
        <NavigationBlockerProvider>
          <AdminView />
        </NavigationBlockerProvider>
      </AdminProvider>
    ),
  },
]);

const AdminApp = () => <RouterProvider router={router} />;

export default AdminApp;
